var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 341,
    height: 36,
    viewBox: "0 0 341 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1789",
    "data-name": "Groupe 1789",
    transform: "translate(15 -205)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_2",
    "data-name": "Ligne 2",
    x2: 304.679,
    transform: "translate(3.375 222.625)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1610",
    "data-name": "Groupe 1610",
    transform: "translate(-15 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    fill: "#f7c030",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks",
    "data-name": "Bienvenue sur Quicks",
    d: "M10.691,15.648V7.359H8.733V5.59h4.05V15.648Z",
    transform: "translate(6.817 6.852)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1611",
    "data-name": "Groupe 1611",
    transform: "translate(35.747 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-2",
    "data-name": "Rectangle 250",
    fill: "#e0df61",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1612",
    "data-name": "Groupe 1612",
    transform: "translate(86.494 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-3",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1613",
    "data-name": "Groupe 1613",
    transform: "translate(137.241 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-4",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1614",
    "data-name": "Groupe 1614",
    transform: "translate(187.47 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-5",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1615",
    "data-name": "Groupe 1615",
    transform: "translate(238.735 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-6",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1616",
    "data-name": "Groupe 1616",
    transform: "translate(290 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_250-7",
    "data-name": "Rectangle 250",
    fill: "#818b8e",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Bienvenue_sur_Quicks-2",
    "data-name": "Bienvenue sur Quicks",
    d: "M7.37,15.594v-1.62l2.7-2.781q.8-.823,1.208-1.3a3.964,3.964,0,0,0,.567-.8A1.462,1.462,0,0,0,12,8.452a1.1,1.1,0,0,0-.358-.871,1.3,1.3,0,0,0-.9-.317,1.622,1.622,0,0,0-.986.317,1.826,1.826,0,0,0-.635.965L7.3,7.953a2.912,2.912,0,0,1,.675-1.363,3.5,3.5,0,0,1,1.242-.9,3.783,3.783,0,0,1,1.526-.317,4.127,4.127,0,0,1,1.755.351,2.76,2.76,0,0,1,1.174.985A2.635,2.635,0,0,1,14.093,8.2a3.079,3.079,0,0,1-.189,1.06,4.359,4.359,0,0,1-.574,1.053,10.334,10.334,0,0,1-.992,1.154l-2.309,2.376h4.158v1.755Z",
    transform: "translate(43.003 211.906)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.d66c17c5a6b33f5d80987b3bdd718329.svg";
export { ForwardRef as ReactComponent };